package top.wcpe.allincore.ui.runtime.ir.call

import kotlin.jvm.JvmField

/**
 * action 上报通道：客户端解释器在执行完 action body 后，调用此接口通知服务端。
 *
 * M5 不做参数透传，仅传递 actionName。
 */
interface ActionDispatcher {

    /** 通知服务端：当前 session 触发了某个 action。 */
    fun send(actionName: String)

    companion object {
        /** 空实现，便于测试或离线模式。 */
        @JvmField
        val NOOP: ActionDispatcher = object : ActionDispatcher {
            override fun send(actionName: String) {
                // 无操作
            }
        }
    }
}
